define('utils',['jquery', 'knockout', 'moment', 'bootstrap'], function ($, ko) {

    ko.bindingHandlers.fadeVisible = {
        init: function (element) {
            $(element).removeClass('hidden').removeClass('fade');
            $(element).hide();
        },
        update: function (element, valueAccessor) {
            var value = valueAccessor();
            ko.utils.unwrapObservable(value) ? $(element).fadeIn() : $(element).fadeOut();
        }
    };

    String.prototype.unescapeNewLines = function() {
        return this.replace(/\\n/g, '\n');
    }

    String.prototype.convertNewLinesToHtml = function() {
        return this.replace(/(\n)|(\\n)/g, '<br>');
    }

    return {
        stringStartsWith: function (string, startsWith) {
            string = string || "";
            if (startsWith.length > string.length)
                return false;
            return string.substring(0, startsWith.length) === startsWith;
        },
        
        getSectionNameForLayerType: function(layerType) {
            switch (layerType) {
                case "Circle":
                case "Rectangle":
                case "Polyline":
                case "Polygon":
                case "GeoJSON":
                case "KML":
                    return "vectors";
                case "Boundary":
                    return "boundaries";
                case "Marker":
                case "Directions":
                    return "markers";
                case "Overlay":
                    return "overlays";
                default:
                    return "controls";
            }
        },
        
        isEmptyGuid: function(guid) {
            return guid === '00000000000000000000000000000000';
        }
    };
});
